import * as React from 'react';
export const skillsSvg = React.forwardRef(function skillsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.483 7.995a.8.8 0 0 1 1.569.317l-1.425 7.05a.8.8 0 0 1-1.568-.317l1.424-7.05ZM6.867 9.009a.751.751 0 0 1 1.22.872l-1.179 1.648 1.179 1.65a.75.75 0 1 1-1.219.873l-1.284-1.795a1.25 1.25 0 0 1 0-1.454l1.283-1.794Zm6.573-.175a.751.751 0 0 1 1.046.175l1.284 1.794c.31.435.31 1.019 0 1.454l-1.285 1.795a.75.75 0 0 1-1.218-.873l1.178-1.65-1.18-1.648a.751.751 0 0 1 .175-1.047Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.336 0c.464 0 .91.185 1.237.513L7.061 1h6.189A2.75 2.75 0 0 1 16 3.75V7a.75.75 0 0 1-1.5 0V3.75c0-.69-.56-1.25-1.25-1.25h-6.5a.75.75 0 0 1-.53-.22l-.707-.707a.25.25 0 0 0-.177-.073H2.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h.5a.75.75 0 0 1 0 1.5h-.5A2.75 2.75 0 0 1 0 10.75v-8A2.75 2.75 0 0 1 2.75 0h2.586Z',
    }),
  );
});
skillsSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var skills = {
  category: 'icon',
  colorable: true,
  name: 'skills',
  svg: skillsSvg,
};
